export default class SiteMapNavigation extends HTMLElement {

    siteMap;
    config;
    list;

    constructor(config, siteMap) {
        super();

        this.config = config;
        this.siteMap = siteMap;
    }

    async connectedCallback() {
        if (this.config.groups == null)
            return;

        this.initNavigationList();
        this.initNavigationElements();
    }

    initNavigationList() {
        let template = document.querySelector('template#navigation-list');
        if (template == null) {
            template = document.createElement('template');
            template.innerHTML = navigationListTemplate;    
        }

        const list = template.content.cloneNode(true);
        
        this.appendChild(list);

        this.list = this.lastElementChild;
    }

    initNavigationElements() {
        let template = document.querySelector('template#navigation-element');
        if (template == null) {
            template = document.createElement('template');
            template.innerHTML = navigationElementTemplate;    
        }

        const siteMap = this.siteMap;
        this.config.groups.forEach((group) => {
            let navigationElement = template.content.cloneNode(true);

            const content = navigationElement.querySelector('[data-navigation-content]');
            content.innerText = group.label;

            this.list.appendChild(navigationElement);
            if (!group.hidable)
                return;

            navigationElement = this.list.lastElementChild;

            navigationElement.setAttribute('data-hidable', '');

            navigationElement.addEventListener('click', () => {
                siteMap.toggleGroup(group.object);

                if (navigationElement.hasAttribute('data-hidden')) {
                    navigationElement.removeAttribute('data-hidden');
                } else {
                    navigationElement.setAttribute('data-hidden', '');
                }
            });
        });
    }
}

const navigationElementTemplate = '<li class="site-map-navigation__list-item"><button class="site-map-navigation__list-button" type="button" data-navigation-content></button></li>';
const navigationListTemplate = '<ul class="site-map-navigation__list"></ul>';